import { Link as RouterLink, generatePath } from 'react-router';

import ActionButton from '../../../../components/ActionButton/index.ts';
import Section from '../../../../components/Section/index.ts';
import { LANG } from '../../../../services/Config.js';

const RefinancingArticle = () => {
  const { routes } = LANG;

  return (
    <>
      <Section>
        <div className="max-w-[1200px]">
          <h1 className="mb-6 typography-v1-h2 text-[#18A0FB] sm:mb-8">Refinansiering</h1>
          <h3 className="mb-4 typography-v1-legacy-subtitle1Bold">
            Refinansiering handler om å samle smålån i et gunstigere felleslån. Men hva betyr det
            egentlig, og hvordan gjør du det? Vi guider deg gjennom det du trenger å vite om
            refinansiering.
          </h3>
          <p className="typography-v1-legacy-subtitle2">
            Har du mer enn ett lån? Da er du ikke alene. Boliglån og billån er vanlig, og i tillegg
            har vi gjerne forbrukslån og kredittkort. Ulempen med denne typen smålån er at de som
            regel er dyre. Da er det lurt å se på en refinansiering – det kan nemlig være tusener å
            spare hver måned. Men la oss først ta et dypdykk i hva refinansiering er.
          </p>
        </div>
      </Section>

      <Section background="paper">
        <div className="flex max-w-[1200px] flex-col sm:flex-row">
          <div className="w-full max-w-[1200px] pr-0 sm:w-1/2 sm:pr-6">
            {/* 1 */}
            <h3 className="mb-4 typography-v1-legacy-subtitle1Bold">Hva er refinansiering?</h3>
            <p className="mb-8 typography-v1-legacy-p3 sm:mb-14">
              Enkelt forklart er refinansiering å samle mange og dyre smålån med høy rente, til ett
              større og billigere lån med lavere rente. Disse smålånene kan være forbrukslån,
              kredittkortgjeld og handlekontoer.
            </p>

            {/* 2 */}
            <h3 className="mb-4 typography-v1-legacy-subtitle1Bold">Refinansiere forbrukslån?</h3>
            <p className="mb-8 typography-v1-legacy-p3 sm:mb-14">
              Har du mange forbrukslån, vil det sannsynligvis lønne seg å refinansiere. Du bør
              likevel vite at ikke alle får lavere rente, fordi det blant annet avhenger av
              økonomien og betalingsevnen din. Når det er sagt, får de aller fleste lavere rente enn
              de har på smålånene sine.
              <br />
              <br />
              Synes du det er vanskelig å orientere deg i jungelen av banker som tilbyr
              refinansiering av forbrukslån? Det er her{' '}
              <RouterLink
                to={routes.HOME}
                className="typography-v1-legacy-p3 text-[#18A0FB] underline"
              >
                Scoopr
              </RouterLink>{' '}
              kommer inn i bildet. For det er enkelt å sjekke om du kan få lavere rente med en
              refinansiering, og det er enkelt å bytte avtale.
            </p>

            {/* 3 */}
            <h3 className="mb-4 typography-v1-legacy-subtitle1Bold">
              Hvordan refinansiere forbrukslån?
            </h3>
            <p className="typography-v1-legacy-p3">
              Scoopr gjør nemlig jobben for deg – altså sender søknaden din til flere banker. For å{' '}
              <RouterLink
                to={generatePath(routes.PRODUCTS_FAQ_ARTICLE, {
                  articleName: 'hvordan-soker-jeg-pa-refinansiering-hos-scoopr',
                })}
                className="typography-v1-legacy-p3 text-[#18A0FB] underline"
              >
                refinansiere forbrukslån hos Scoopr
              </RouterLink>
              , må du oppfylle noen minstekrav.
            </p>
            <ul className="my-3 list-disc pl-7 typography-v1-legacy-p3">
              <li>Du må være over 18 år</li>
              <li>Du må ha et norsk personnummer</li>
              <li>Du må kunne vise til en årlig inntekt på minst 140.000 kroner før skatt</li>
              <li>Du kan ikke ha noen betalingsanmerkninger</li>
            </ul>
            <p className="mb-8 typography-v1-legacy-p3 sm:mb-14">
              Hvis du har alt dette på plass, kan du gå videre for å søke om refinansiering.
            </p>
          </div>

          <div className="w-full max-w-[1200px] pl-0 sm:w-1/2 sm:pl-6">
            {/* 4 */}
            <h3 className="mb-4 typography-v1-legacy-subtitle1Bold">Hva betyr refinansiering?</h3>
            <p className="typography-v1-legacy-p3">
              Refinansiering betyr at du får en bedre deal på ett lån enn du får på mange smålån.
              Med andre ord kan du kutte ned på beløpet du betaler hver måned, og spare penger. Når
              du refinansierer, får du flere fordeler:
            </p>
            <ul className="my-3 list-disc pl-7 typography-v1-legacy-p3">
              <li>Du kan få lavere rente</li>
              <li>Du får færre gebyrer</li>
              <li>Du får én bank å forholde deg til</li>
              <li>Du får én månedlig regning</li>
              <li>Du unngår unødvendige kostnader</li>
              <li>Du får bedre oversikt</li>
              <li>Du får lavere totale kostnader</li>
              <li>Du kan begynne å spare penger til en buffer</li>
            </ul>
            <p className="mb-8 typography-v1-legacy-p3 sm:mb-14">
              Alt i alt – med refinansiering trenger du ikke å betale mer enn du må.
            </p>

            {/* 5 */}
            <h3 className="mb-4 typography-v1-legacy-subtitle1Bold">
              Hvordan søke refinansiering?
            </h3>
            <p className="mb-8 typography-v1-legacy-p3 sm:mb-14">
              Hos Scoopr kan du søke om refinansiering fra 20.000 til 500.000 kroner. Det er enkelt,
              gratis og uforpliktende, og tar deg kun to minutter.
              <br />
              <br />
              <RouterLink
                to={generatePath(routes.PRODUCTS_FAQ_ARTICLE, {
                  articleName: 'hvordan-soker-jeg-pa-refinansiering-hos-scoopr',
                })}
                className="typography-v1-legacy-p3 text-[#18A0FB] underline"
              >
                Du søker refinansiering her
              </RouterLink>
              . Legg inn opplysningene dine, og så blir søknaden automatisk sendt til 13 banker. De
              gjør en individuell vurdering av betalingsevnen din der de blant annet sjekker
              inntekt, betjeningsevne, kredittverdighet, om du allerede har gjeld og hvor høy den
              er.
              <br />
              <br />
              Som regel får du svar på søknaden din etter kort tid. Hvis søknaden blir godkjent
              trenger du ikke å gjøre noe mer –{' '}
              <RouterLink
                to={generatePath(routes.PRODUCTS_FAQ_ARTICLE, {
                  articleName: 'betaler-dere-ut-min-eksisterende-gjeld',
                })}
                className="typography-v1-legacy-p3 text-[#18A0FB] underline"
              >
                da betaler normalt banken den gamle gjelden din
              </RouterLink>
              . Du sparer både tid og arbeid, og i tillegg kan du være sikker på at den gamle og
              dyre gjelden din faktisk blir nedbetalt.
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center">
          <h3 className="my-14 max-w-[1200px] text-center typography-v1-legacy-subtitle1Bold">
            Sjekk hvor mye du kan spare på refinansiering hos Scoopr i dag.
          </h3>
          <ActionButton
            label="Søk refinansiering hos Scoopr"
            flow="debt_check"
            step="skip_start_from_refinansiering"
            color="secondary"
          />
        </div>
      </Section>
    </>
  );
};

export default RefinancingArticle;
